// User-facing chrome strings.
//
// Every entry is a `LocalizedText`, so omitting a translation is a compile
// error rather than a silent gap.

import type { LocalizedText } from './locale';

/** Top-nav route names. */
export const NAV: Record<'portal' | 'device' | 'developer', LocalizedText> = {
  portal: { en: 'portal', zh: '门户' },
  device: { en: 'device', zh: '设备' },
  developer: { en: 'developer', zh: '开发者' },
};

export const NAV_UI = {
  home: { en: 'Go home', zh: '返回首页' },
  settings: { en: 'Open settings', zh: '打开设置' },
} satisfies Record<string, LocalizedText>;

export const PORTAL_UI = {
  pageTitle: { en: 'Developer portal', zh: '开发者门户' },
  pageSubtitle: {
    en: 'Echo Engine documentation is published on the EchoPlay developer portal. Choose the region closest to you.',
    zh: 'Echo Engine 文档发布于 EchoPlay 开发者门户。请选择离你最近的区域。',
  },
  regionsHeading: { en: 'Regional portals', zh: '区域门户' },
  openLabel: { en: 'Open portal', zh: '打开门户' },
  opensInNewTab: { en: 'Opens in a new tab', zh: '在新标签页中打开' },
  languageNote: {
    en: 'Menu language follows the language selected in Settings.',
    zh: '菜单语言跟随“设置”中所选的语言。',
  },
  openSettings: { en: 'Open settings', zh: '打开设置' },
  backToDemo: { en: 'Back to the demo', zh: '返回演示' },
} satisfies Record<string, LocalizedText>;

export const SETTINGS_UI = {
  pageTitle: { en: 'Settings', zh: '设置' },
  currentBuild: { en: 'Current build', zh: '当前构建' },
  languageLabel: { en: 'Language', zh: '语言' },
  languageDescription: {
    en: 'Applies to menus, robot selection, and the repair-shop game poster.',
    zh: '适用于菜单、机器人选择以及维修车间的游戏海报。',
  },
  audioLabel:{en:'Audio',zh:'音频'},
  soundEffects:{en:'Sound effects',zh:'音效'},
  soundEffectsDescription:{en:'Workshop, combat, and interface sounds.',zh:'车间、战斗及界面音效。'},
  music:{en:'Music',zh:'音乐'},
  musicDescription:{en:'Background music, when available. Saved separately from sound effects.',zh:'有背景音乐时播放。此设置与音效分别保存。'},
} satisfies Record<string, LocalizedText>;
